import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {httpOptions} from '../../../configurations/configuration';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { VenueType } from '../../../models/venue/venue-type';

@Injectable({
  providedIn: 'root'
})
export class VenueTypeService {
  venueType:string;
  constructor(private http: HttpClient) {
    this.venueType = environment.baseURI + environment.apiUrl + 'venue/getAllVenueType';
  }

  getAllVenueType(): Observable<VenueType> {
    return this.http.get<VenueType>(this.venueType);
  }
}
